import * as React from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { Box } from "@mui/system";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import ProfileContext from "../../context/ProfileContext";
import useAuth from "../../hooks/useAuth";
import { Avatar } from "@mui/material";

function SectionComponentForRequestedCourses({
  section,
  sectionID,
  courseCode,
  courseDept,
  courseOwner,
  getCourseGroups,
  owned,
}) {
  let api = useAxiosPrivate();

  let [requestedGroups, setRequestedGroups] = React.useState([]);
  let [requestedSections, setrequestedSections] = React.useState([]);
  let [found, setFound] = React.useState(false);

  let [isMounted, setIsMounted] = React.useState(true);

  let {state}=React.useContext(ProfileContext)
  let {user}=useAuth()

  React.useEffect(() => {
    setIsMounted(true);
    const controller = new AbortController();

    getRequestedStaff(controller.signal);
    setFound(false);

    return () => {
      setIsMounted(false);
      controller.abort();
    };
  }, []);

  function containsObj(obj) {
    let found = false;

    for (let i = 0; i < requestedGroups.length; i++) {
      if (
        requestedGroups[i].course_code === obj.course_code &&
        requestedGroups[i].group_id === obj.group_id
      ) {
        found = true;
      }
    }

    return found;
  }

  async function getRequestedStaff(signal) {
    let resp = await api.get("courseallocation/sentrequesthistory", {
      signal,
    });

    isMounted && setRequestedGroups(resp.data.newRequests);
    isMounted && setrequestedSections(resp.data.sectionsrequestedfor);
  }

  return (
    <React.Fragment>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Box
          sx={{
            color: "brown",
            marginRight: 3,
            marginBottom: 3,
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-around",
            alignItems: "center",
          }}
        >
          Section {section.title}
        </Box>

        <TableContainer
          sx={{
            border: 2,
            borderColor: "#cd853f",
            minWidth: "80%",
            width: "80%",
            marginBottom: 4,
            minheight: "300px",
          }}
        >
          <Table
            sx={{
              minWidth: "80%",
              width: "80%",
              border: 0,
              minheight: "300px",
            }}
            aria-label="simple table"
          >
            <TableHead>
              <TableRow>
                <TableCell sx={{ fontWeight: "bold", fontSize: 16 }}>
                  Group
                </TableCell>
                <TableCell
                  align="left"
                  sx={{ fontWeight: "bold", fontSize: 16 }}
                >
                  Load
                </TableCell>
                <TableCell
                  align="center"
                  sx={{ fontWeight: "bold", fontSize: 16 }}
                >
                  Allocated Staff
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {section.Groups !== null ? (
                section.Groups.map((group, index) => (
                  <TableRow key={index} sx={{ border: 0 }}>
                    <TableCell component="th" scope="row">
                      {group.type}
                    </TableCell>
                    <TableCell
                      align="left"
                      sx={{ fontWeight: "bold", fontSize: 16 }}
                    >
                      {group.Load_leh}
                    </TableCell>
                    <TableCell align="center">
                      {group.assignedstaff !== null && (
                        <div className="section-group-allocated-staff">
                          <Box
                            component={Avatar}
                            sx={{
                              marginRight: 1.5,
                              borderRadius: 40,
                              width: 50,
                              height: 50,
                            }}
                            src={state.host+group.assignedstaff.User?.profile_pic.slice(1,)+`?token=${user?.accessToken}`}

                            // src={require(`../../assets${group.assignedstaff.User.profile_pic}`)}
                          ></Box>
                          <Box
                            sx={{
                              marginTop: 1,
                              marginLeft: -3,
                              fontWeight: 700,
                              fontSize: "18px",
                            }}
                          >
                            {group.assignedstaff.User !== null &&
                              group.assignedstaff.User.first_name}
                          </Box>
                        </div>
                      )}

                      {group.assignedstaff === null &&
                        owned === false &&
                        containsObj({
                          course_code: courseCode,
                          group_id: group.id,
                        }) === true && (
                          <div className="requestStaffstatus">Requested</div>
                        )}

                      {group.assignedstaff === null &&
                        owned === false &&
                        containsObj({
                          course_code: courseCode,
                          group_id: group.id,
                        }) === false && (
                          <div className="requestStaffstatus">Not Assigned</div>
                        )}
                    </TableCell>
                  </TableRow>
                ))
              ) : (
                <h3>No Sections Available</h3>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </div>
    </React.Fragment>
  );
}

export default SectionComponentForRequestedCourses;
